var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 107,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4354 30.1875V17.588C68.5473 15.7529 67.5626 13.336 67.5626 11.6128C67.5626 9.88958 65.5485 10.0015 65.5485 10.0015H59.6851H58.7676H52.9043C52.9043 10.0015 50.8901 9.88958 50.8901 11.6128C50.8901 13.336 49.9054 15.7529 50.0173 17.588V30.1651C50.0173 30.1651 49.6816 32.694 51.9643 32.694H58.7452C59.3047 32.694 59.6628 32.694 59.6628 32.694H66.4437C68.7487 32.694 68.3907 30.1651 68.3907 30.1651L68.4354 30.1875Z",
    fill: "#9E8959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5306",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 32,
    width: 18,
    height: 65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7212 32.6494H50.7578V96.6315H67.7212V32.6494Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6124 26.2934H58.8515C55.156 26.2934 52.1602 29.2893 52.1602 32.9848V88.3509C52.1602 92.0465 55.156 95.0423 58.8515 95.0423H59.6124C63.308 95.0423 66.3038 92.0465 66.3038 88.3509V32.9848C66.3038 29.2893 63.308 26.2934 59.6124 26.2934Z",
    fill: "white",
    strokeWidth: 1.55556,
    strokeMiterlimit: 10,
    stroke: "#05054B"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2383 13.5151V29.0239",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4023 15.417V29.0235",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0469 15.417V29.0235",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6061 41.6265H55.293V84.2541H65.6061",
    strokeWidth: 1.37509,
    stroke: "#9E8959"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 54.9745V55.3701H65.8023V54.9745H61.0195Z",
    fill: "#33333F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 54.5293V54.727H65.8023V54.5293H61.0195Z",
    fill: "#33333F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 53.8862V54.084H65.8023V53.8862H61.0195Z",
    fill: "#33333F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 52.8237V53.0215H65.8023V52.8237H61.0195Z",
    fill: "#33333F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 51.9824V52.1802H65.8023V51.9824H61.0195Z",
    fill: "#33333F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 50.9198V51.3154H65.771V50.9198H60.9883Z",
    fill: "#33333F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 50.4501V50.6479H65.8023V50.4502L61.0195 50.4501Z",
    fill: "#33333F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 49.2139V49.832H65.771V49.2139H60.9883Z",
    fill: "#33333F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 48.1264V48.3242H65.8023V48.1264H61.0195Z",
    fill: "#33333F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 48.5702V48.9658H65.8023V48.5702H61.0195Z",
    fill: "#33333F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 47.2852V47.9033H65.8023V47.2852H61.0195Z",
    fill: "#33333F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 46.2226V46.6182H65.8023V46.2226H61.0195Z",
    fill: "#33333F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 45.7519V45.9497H65.8023V45.7519H61.0195Z",
    fill: "#33333F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 64.6005V64.9961H65.8023V64.6005H61.0195Z",
    fill: "#33333F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 64.1552V64.353H65.8023V64.1552H61.0195Z",
    fill: "#33333F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 63.5126V63.7104H65.8023V63.5127L61.0195 63.5126Z",
    fill: "#33333F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 62.4492V62.647H65.8023V62.4492H61.0195Z",
    fill: "#33333F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 61.6088V61.8066H65.8023V61.6088H61.0195Z",
    fill: "#33333F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 60.5453V60.9409H65.771V60.5453H60.9883Z",
    fill: "#33333F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 60.0766V60.2744H65.8023V60.0766H61.0195Z",
    fill: "#33333F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 58.8404V59.4585H65.771V58.8404H60.9883Z",
    fill: "#33333F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 57.7529V57.9507H65.8023V57.7529H61.0195Z",
    fill: "#33333F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 58.1967V58.5923H65.8023V58.1967H61.0195Z",
    fill: "#33333F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 56.9112V57.5293H65.8023V56.9112H61.0195Z",
    fill: "#33333F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 55.8485V56.2441H65.8023V55.8485H61.0195Z",
    fill: "#33333F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 55.3784V55.5762H65.8023V55.3784H61.0195Z",
    fill: "#33333F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 74.226V74.6216H65.8023V74.226H61.0195Z",
    fill: "#33333F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 73.7807V73.9785H65.8023V73.7807H61.0195Z",
    fill: "#33333F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 73.1381V73.3359H65.8023V73.1381H61.0195Z",
    fill: "#33333F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 72.0751V72.2729H65.8023V72.0752L61.0195 72.0751Z",
    fill: "#33333F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 71.2338V71.4316H65.8023V71.2338H61.0195Z",
    fill: "#33333F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 70.1713V70.5669H65.771V70.1713H60.9883Z",
    fill: "#33333F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 69.7021V69.8999H65.8023V69.7021H61.0195Z",
    fill: "#33333F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 68.4659V69.084H65.771V68.4659H60.9883Z",
    fill: "#33333F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 67.3779V67.5757H65.8023V67.3779H61.0195Z",
    fill: "#33333F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 67.8222V68.2178H65.8023V67.8222H61.0195Z",
    fill: "#33333F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 66.5367V67.1548H65.8023V66.5367H61.0195Z",
    fill: "#33333F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 65.474V65.8696H65.8023V65.474H61.0195Z",
    fill: "#33333F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0195 65.0039V65.2016H65.8023V65.0039H61.0195Z",
    fill: "#33333F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 77.622V78.0176H65.771V77.622H60.9883Z",
    fill: "#33333F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 77.1762V77.374H65.771V77.1762H60.9883Z",
    fill: "#33333F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 76.5336V76.7314H65.771V76.5336H60.9883Z",
    fill: "#33333F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 75.4707V75.6684H65.771V75.4707H60.9883Z",
    fill: "#33333F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 74.6293V74.8271H65.771V74.6293H60.9883Z",
    fill: "#33333F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2166 57.4905C58.2166 57.4905 58.2447 57.4342 58.2729 57.4342H58.7377C58.7377 57.4342 58.794 57.4623 58.794 57.4905V59.1946C58.794 59.1946 58.7658 59.265 58.7236 59.265C57.3856 59.251 56.5547 58.6454 56.5547 57.3778C56.5547 56.1666 57.3856 55.3779 58.6391 55.3779C59.8925 55.3779 60.7235 56.2089 60.7235 57.4623C60.7235 58.0961 60.5122 58.5608 60.1742 58.9129C60.146 58.9411 60.1179 58.927 60.1038 58.9129L59.6531 58.5468C59.6531 58.5468 59.639 58.5186 59.639 58.5045C59.639 58.4904 59.639 58.4763 59.6531 58.4623C59.808 58.2933 60.0334 57.913 60.0334 57.4482C60.0334 56.6173 59.4841 56.068 58.6532 56.068C57.8222 56.068 57.273 56.5891 57.273 57.3778C57.273 58.0257 57.5969 58.4341 58.2307 58.5468V57.4764L58.2166 57.4905Z",
    fill: "#9E8959"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7235 61.7856C60.7235 63.039 59.8925 63.8559 58.6391 63.8559C57.3856 63.8559 56.5547 63.039 56.5547 61.7856C56.5547 60.5321 57.3856 59.7012 58.6391 59.7012C59.8925 59.7012 60.7235 60.5321 60.7235 61.7856ZM57.2589 61.7856C57.2589 62.6024 57.8081 63.1658 58.6391 63.1658C59.47 63.1658 60.0193 62.6165 60.0193 61.7856C60.0193 60.9546 59.47 60.4053 58.6391 60.4053C57.8081 60.4053 57.2589 60.9546 57.2589 61.7856Z",
    fill: "#9E8959"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2431 66.533C57.2431 66.533 57.2291 66.5893 57.1868 66.5893H56.6657C56.6657 66.5893 56.6094 66.5612 56.6094 66.533V64.5754C56.6094 64.5754 56.6375 64.519 56.6657 64.519H60.6091C60.6091 64.519 60.6655 64.5472 60.6655 64.5754V65.1669C60.6655 65.1669 60.6373 65.2232 60.6091 65.2232H57.2431V66.533Z",
    fill: "#9E8959"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6094 67.236C56.6094 67.236 56.6375 67.1797 56.6657 67.1797H60.6091C60.6091 67.1797 60.6655 67.2078 60.6655 67.236V68.4331C60.6655 69.6725 59.8768 70.5034 58.6374 70.5034C57.3981 70.5034 56.6094 69.6725 56.6094 68.4331V67.236ZM60.0176 67.8839H57.2854V68.4331C57.2854 69.2641 57.8206 69.8133 58.6515 69.8133C59.4825 69.8133 60.0176 69.2641 60.0176 68.4331V67.8839Z",
    fill: "#9E8959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step_2.4e3bfd136fc2411a263d3a41bc7065f5.svg";
export { ForwardRef as ReactComponent };